module.exports = __webpack_public_path__ + "img/referrals.76caebb5.svg";